import { createContext } from 'react';

export const MapContentContext = createContext<null | {
  translations: Record<string, string>;
}>(null);
